<script>
import UsersListSearch from "./sub-components/UsersListSearch";
import DibbleJS from "../../dibble";
import DibbleAPI from "../../api";
import ModalAddNewUser from "./sub-components/ModalAddNewUser";
import DibbleApi from "@/api";

export default {
    name: "UsersList",
    components: {
        UsersListSearch, ModalAddNewUser
    },
    data() {
        return {
            dibbleJs: DibbleJS,
            users: [],
            userPermissionLevels: null,
            editablePermissionLevels: null,
            isShowModalUserForm: false,
        }
    },
    created() {
        this.loadUsers()
    },
    methods: {
        loadUsers() {
            DibbleJS.showLoader()
            DibbleJS.callApiRequest({
                '#request': DibbleAPI.api.getUsers
            }, (response) => {
                DibbleJS.hideLoader()
                if (DibbleAPI.isResponseSuccess(response)) {

                    this.users = response['users']
                    this.userPermissionLevels = response['all_permission_level']
                    this.editablePermissionLevels = response['editable_permission_level']

                    this.users.forEach((user) => {
                        user['showAction'] = 0
                    })
                } else {
                    DibbleJS.toastErrorMessage(response.message)
                }
            }, this._onRequestFailed)
        },
        showUserModal(mode = 'add') {
            this.$refs.userFormRef.resetModalData()
            if (mode === 'add') {
                this.isShowModalUserForm = true
            }
        },
        editUser(user) {
            this.$emit('setUserData', user)
            this.isShowModalUserForm = true
        },
        modalListenerHandler(eventStr) {
            switch (eventStr) {
                case 'reload':
                    this.isShowModalUserForm = false
                    this.loadUsers()
                    break;
            }
        },
        setUserActive(user, is_active) {
            DibbleJS.showLoader()
            DibbleJS.callApiRequest({
                '#request': DibbleAPI.api.setUserActive,
                user_id: user.user_id,
                is_active: is_active
            }, (response) => {
                DibbleJS.hideLoader()
                if (DibbleAPI.isResponseSuccess(response)) {
                    DibbleJS.toastSuccessMessage('User status updated')
                    this.loadUsers()
                } else {
                    DibbleJS.toastErrorMessage(response.message)
                }
            }, this._onRequestFailed)
        },
        showItemAction(item) {
            const items = this.users;
            const index = items.findIndex((x) => x.user_id === item.user_id);
            const isOpened = items[index].showAction;

            items.forEach((item, index) => {
                items[index].showAction = false;
            });

            if (!isOpened)
                items[index].showAction = true;
            else
                items[index].showAction = false;

            this.users = [];
            this.users = items;
        },
        hideAction() {
            const items = this.users;
            items.forEach((item, index) => {
                items[index].showAction = false;
            });
            this.users = [];
            this.users = items;
        },
        resendInvitation(user) {
            this.hideAction()
            DibbleJS.showLoader()
            DibbleJS.callApiRequest({
                '#request': DibbleAPI.api.resendInvitationToUser,
                user_id: user.user_id
            }, (response) => {
                DibbleJS.hideLoader()
                if (DibbleAPI.isResponseSuccess(response)) {
                    DibbleJS.toastSuccessMessage('Invitation has been sent')
                } else {
                    DibbleJS.toastErrorMessage(response.message)
                }
            }, this._onRequestFailed)
        },
        showConfirmDelete(user) {
            DibbleJS.confirmBox('Are you sure you want to delete this user?', () => {
                DibbleJS.showLoader()
                this.hideAction()
                DibbleJS.callApiRequest({
                    '#request': DibbleApi.api.deleteUser,
                    user_id: user.user_id
                }, (response) => {
                    DibbleJS.hideLoader();
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage('User has been deleted')
                        this.loadUsers()
                    } else {
                        DibbleJS.toastErrorMessage(response.message)
                    }
                }, this._onLoadBoatTypeFailed)
            })
        },
        _onRequestFailed(error) {
            DibbleJS.hideLoader();
            console.log(error)
            DibbleJS.toastErrorMessage('Something wrong! can not load data');
        },
    }
}
</script>
<template src="./template/users-list.html"></template>
<style lang="scss" scoped>
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}
.payment-page {
    display: flex;
    flex-direction: column;
    user-select: none;
    min-width: 900px;

    p {
        font-family: "Open Sans";
        font-style: normal;
    }

    .title-payment {
        display: flex;
        justify-content: space-between;

        p {
            font-weight: 600;
            font-size: 22px;
            color: #1c5169;
        }

        button {
            background: #1c5169;
            box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
            border-radius: 20px;
            width: 61px;
            height: 47px;
            color: #fff;
            font-size: 30px;
            border: none;
        }
    }

    table {
        width: 100%;
        user-select: none;

        tr {
            user-select: none;
            border-bottom: 1.5px solid #dee6ea;
        }

        th {
            padding-top: 20px;
            padding-bottom: 20px;
            user-select: none;
            font-family: 'Open Sans';
            font-style: normal;
        }

        img {
            cursor: pointer;
        }

        .title-col {
            font-weight: 600;
            font-size: 20px;
            color: #2C94AB;
        }

        .text-name {
            font-weight: 600;
            font-size: 20px;
            color: #555E67;
        }

        .text-default {
            font-weight: 400;
            font-size: 20px;
            color: #7C7C7A;
        }
    }
}

.user-status {
    .checkmark-new {
        height: 24px;
        width: 24px;
        border-radius: 6px;
        &.active {
            background-color: #1c5269 !important;
        }
        &.inactive {
            background-color: #a0a0a0 !important;
        }

        &.disabled {
            opacity: 0.3;
        }

        &:after {
            left: 8px;
            top: 3px;
        }
    }
}

.user-status.x-mark {
    .checkmark-new {
        &:after {
            content: "X";
            left: 8px !important;
            top: 1px;
            font-size: 14px;
            font-weight: bold;
            color: #FFFFFF;
            border: none !important;
            transform: none;
        }
    }
}

.dropdown-btn {
    position: relative;

    span {
        display: block;

        &.top {
            font-size: 12px;
            line-height: 16px;
            color: #555E67;
        }
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        right: 100px;
        z-index: 1000;
        display: none;
        min-width: 3rem;
        text-align: left;
        list-style: none;

        background-clip: padding-box;
        border: none;
        border-radius: 30px;
        width: 175px;
        background: none;

        &.active {
            display: block;
        }

        .dropdown-item {
            color: #555E67;
            font-size: 20px;
            font-weight: 700;
            background-color: #EDF5F7;
            padding: 12px 35px;
            border-bottom: 1px solid #DEE6EA;

            &:first-child {
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
            }

            &:last-child {
                border-bottom-left-radius: 30px;
                border-bottom-right-radius: 30px;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
            }

            &:hover {
                background-color: #bae3ef;
                color: #2178AB;
            }
        }
    }
}
.cursor-pointer {
    cursor: pointer;
}
.c-btn-add {
    color: #fff;
    width: 61px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 24px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
</style>
